import React from 'react';
import moment from 'moment';
import PropTypes from 'prop-types';
import Event from '../Event/EventComponent';
import './DayGridComponent.scss';

function dfs(index, events, maxEventsCollision, visited, left) {
  let tempIndex;
  let flag = 0;
  const maxEventsCollisionCopy = maxEventsCollision;
  const visitedCopy = visited;
  const positions = events;
  visitedCopy[index] = true;
  if (left === undefined) {
    for (tempIndex = index + 1; tempIndex < events.length; tempIndex += 1) {
      if (
        events[tempIndex].StartTime < events[index].EndTime &&
        events[tempIndex].StartTime >= events[index].StartTime
      ) {
        if (!visited[tempIndex]) {
          dfs(tempIndex, events, maxEventsCollisionCopy, visited);
        }
        if (1 + maxEventsCollisionCopy[tempIndex] > maxEventsCollisionCopy[index]) {
          maxEventsCollisionCopy[index] = 1 + maxEventsCollisionCopy[tempIndex];
        }
        flag = 1;
      }
    }
    if (flag === 0) {
      maxEventsCollisionCopy[index] = 1;
    }
  } else {
    flag = 0;
    positions[index].left = left;
    positions[index].width = (100 - left) / maxEventsCollisionCopy[index];
    const leftToSend = events[index].left + events[index].width;
    for (tempIndex = index + 1; tempIndex < events.length; tempIndex += 1) {
      if (
        events[tempIndex].StartTime < events[index].EndTime &&
        events[tempIndex].StartTime >= events[index].StartTime
      ) {
        flag = 1;
        if (!visited[tempIndex]) {
          dfs(tempIndex, events, maxEventsCollisionCopy, visited, leftToSend);
        }
      }
    }
  }
}

function getPositions(events) {
  const positions = events;
  let index;
  const maxEventsCollision = [];
  const visited = [];
  for (index = 0; index < positions.length; index += 1) {
    maxEventsCollision.push(0);
    visited.push(false);
  }
  for (index = 0; index < positions.length; index += 1) {
    if (!visited[index]) {
      dfs(index, positions, maxEventsCollision, visited);
    }
  }
  for (index = 0; index < positions.length; index += 1) {
    visited[index] = false;
  }
  for (index = 0; index < positions.length; index += 1) {
    if (!visited[index]) {
      dfs(index, positions, maxEventsCollision, visited, 0);
    }
  }
  return positions;
}

const wallSeconds = time => time.hour() * 3600 + time.minute() * 60 + time.second();

class DayGrid extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      pageLoad: false,
    };
    this.currentTimeRef = React.createRef();
  }

  componentWillReceiveProps(nextProps) {
    const { startingFreeTime, date } = this.props;
    if (
      (startingFreeTime === '' && nextProps.startingFreeTime !== '') ||
      (moment(date).format() !== moment(nextProps.date).format() && nextProps.date)
    ) {
      this.setState({
        pageLoad: true,
      });
    } else {
      this.setState({
        pageLoad: false,
      });
    }
  }

  componentDidUpdate() {
    const { pageLoad } = this.state;
    if (this.currentTimeRef.current && pageLoad) {
      this.currentTimeRef.current.scrollIntoView({
        behavior: 'smooth',
        block:'center'
      });
    }
  }

  render() {
    const day = [];
    const { startingFreeTime, date, parent, deleteEvent, updateEvent } = this.props;
    const { events, busySlots } = this.props;
    const totalSlots = [];
    let index = 0;
    let index1 = 0;
    events.sort((a, b) => a.StartTime - b.StartTime);
    while (events[index] !== undefined || busySlots[index1] !== undefined) {
      if (events[index] === undefined) {
        totalSlots.push(busySlots[index1]);
        index1 += 1;
      } else if (busySlots[index1] === undefined) {
        totalSlots.push(events[index]);
        index += 1;
      } else if (events[index].StartTime > busySlots[index1].StartTime) {
        totalSlots.push(busySlots[index1]);
        index1 += 1;
      } else {
        totalSlots.push(events[index]);
        index += 1;
      }
    }
    const currentStartSec = wallSeconds(moment());
    const workingHour = moment.utc(`${moment(date).format('YYYY-MM-DD')}T${startingFreeTime}`).local();
    const startWorkingHourSec = wallSeconds(workingHour);
    const startWorkingHourPerc = `${(Math.round((startWorkingHourSec / 864) * 100) / 100).toString()}%`;
    const currentStartWidthPerc = `${(Math.round((currentStartSec / 864) * 100) / 100).toString()}%`;
    for (index = 1; index <= 24; index += 1) {
      day.push(
        <React.Fragment key={index}>
          <div className="first-half" />
          <div className="second-half" />
        </React.Fragment>
      );
    }
    const positions = getPositions(totalSlots);
    for (index = 0; index < totalSlots.length; index += 1) {
      const startMoment = moment.utc(totalSlots[index].StartTime).local();
      const endMoment = moment.utc(totalSlots[index].EndTime).local();
      const startDate = startMoment.format('YYYY-MM-DD HH:mm:ss');
      const endDate = endMoment.format('YYYY-MM-DD HH:mm:ss');
      const gridDate = moment(date);
      const eventCheckForDay = endMoment.isBefore(gridDate, 'day') || startMoment.isAfter(gridDate, 'day');
      const startSec = startMoment.isBefore(gridDate, 'day') ? 0 : wallSeconds(startMoment);
      let endSec = endMoment.isAfter(gridDate, 'day') ? 86400 : wallSeconds(endMoment);
      if (startMoment.isSame(gridDate, 'day') && endMoment.isSame(gridDate, 'day') &&
        endSec <= startSec && endMoment.isAfter(startMoment)) {
        endSec = Math.min(86400, startSec + endMoment.diff(startMoment, 'seconds'));
      }
      const startWidthPerc = `${(Math.round((startSec / 864) * 100) / 100).toString()}%`;
      const heightPerc = `${(Math.round(((endSec - startSec) / 864) * 100) / 100).toString()}%`;
      const widthPerc = `${positions[index].width}%`;
      const leftPerc = `${positions[index].left}%`;
      const styleCss = {
        WebkitTransition: 'all',
        msTransition: 'all',
        top: startWidthPerc,
        height: heightPerc,
        position: 'absolute',
        fontSize: '12px',
        fontWeight: 500,
        width: widthPerc,
        left: leftPerc,
        overflow: 'hidden',
        minHeight: '1%',
      };
      if (!eventCheckForDay) {
        if (totalSlots[index].EventId != null) {
          day.push(
            <Event
              style={styleCss}
              key={`event${index}`}
              parent={parent}
              startDate={moment(startDate)}
              endDate={moment(endDate)}
              event={totalSlots[index]}
              updateEvent={updateEvent}
              type="arya"
              deleteEvent={deleteEvent}
            />
          );
        } else {
          day.push(
            <Event
              style={styleCss}
              key={`event${index}`}
              parent={parent}
              startDate={moment(startDate)}
              endDate={moment(endDate)}
              event={totalSlots[index]}
              updateEvent={updateEvent}
              type="external"
              deleteEvent={deleteEvent}
            />
          );
        }
      }
    }
    const currentTimeStyleCss = {
      WebkitTransition: 'all',
      msTransition: 'all',
      top: currentStartWidthPerc,
      position: 'absolute',
      backgroundColor: 'red',
      width: '100%',
      height: '2px',
    };

    if (moment(date).isSame(moment(), 'day')) {
      day.push(<div style={currentTimeStyleCss} key="current-time" ref={this.currentTimeRef} />);
    }
    day.push(
      <div
        className="scroll-start-working-hours"
        style={{ top: startWorkingHourPerc }}
        key="start-working-hours"
        ref={this.startWorkingHours}
      />
    );
    return <div className={parent}>{day}</div>;
  }
}

DayGrid.propTypes = {
  events: PropTypes.arrayOf(PropTypes.shape({})),
  busySlots: PropTypes.arrayOf(PropTypes.shape({})),
  startingFreeTime: PropTypes.string,
  date: PropTypes.shape({}),
  parent: PropTypes.string,
  updateEvent: PropTypes.func.isRequired,
  deleteEvent: PropTypes.func.isRequired,
};

DayGrid.defaultProps = {
  events: [],
  busySlots: [],
  date: undefined,
  parent: '',
  startingFreeTime: '',
};

export default DayGrid;
